export default (that) => [
  {
    text: that.$l('INDEX.btn_print') || '打印',
    icon: 'el-icon-printer',
    menuType: 'print',
    type: 'Y',
    // divided: true,
    allow: 'E',
    data: {},
    disabled: ({ status }) => !['R', 'T', 'S'].includes(status)
  },
  {
    text: that.$l('btn_print_accept') || '打印让步接受申请',
    icon: 'el-icon-printer',
    menuType: 'print',
    divided: true,
    type: 'R',
    allow: 'E',
    data: {},
    disabled: ({ auditResultType, status }) => {
      if (status == 'R') return false
      return !['R'].includes(auditResultType) || !['R', 'S'].includes(status)
    }
  },
  {
    text: that.$l('btn_print_return') || '打印退货申请',
    icon: 'el-icon-printer',
    menuType: 'print',
    divided: true,
    type: 'T',
    allow: 'E',
    data: {},
    disabled: ({ auditResultType, status }) => {
      if (status == 'T') return false
      return !['T'].includes(auditResultType) || !['T', 'S'].includes(status)
    }
  },
  {
    text: that.$l('btn_export_excel') || '导出Excel',
    icon: 'el-icon-download',
    menuType: 'export',
    divided: true,
    type: 'Y',
    // divided: true,
    allow: 'EX',
    data: {},
    disabled: ({ status }) => !['R', 'T', 'S'].includes(status)
  },
  {
    text: that.$l('btn_delete_report') || '删除报告',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    data: {},
    disabled: ({ status }) => !['N', 'Q'].includes(status),
  },
  {
    text: that.$l('btn_rollback_report') || '回退',
    icon: 'el-icon-refresh-left',
    menuType: 'rollback',
    divided: true,
    allow: 'RB',
    data: {},
    disabled: ({ status }) => status !== 'S',
  },

]
